/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
module.exports = {
	functions: {
		'DIALOG.SHOW': {
			cellEditor: false,
			default: {
				category: 'Events',
				description: 'It is possible to export data to the App Files of an App (e.g. TIMESCALE.EXPORT()). Usually it is possible to access the App Files over the left side menu. This menu is not accessible, if you only want to allow your user to be able to access a build App via the "preview" or "share App" mode. The DIALOG.SHOW() function allows opening the App Files via event on a shape or object.',
				inlineDescription: 'Open the App Files via event on a shape or object.',
				hint: 'This function should not be used in a cell',
				return: {
					type: 'Boolean',
					description: 'TRUE.'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=DIALOG.SHOW()',
							comment: 'Open the App File Dialog via event assigned to a shape.'
						}
					]
				}
			}
		},
		SHOWVALUES: {
			cellEditor: false,
			default: {
				category: 'Events',
				description: 'To display values from a query in a boxed table use the SHOWVALUES() function in an event. Select the source and the size of your table, a event should trigger. The table can be scrolled through and closed again.',
				inlineDescription: 'To display values from a query in a boxed table.',
				hint: 'This function should not be used in a cell',
				arguments: [
					{
						type: 'Cell',
						name: 'Datasource',
						description: 'A cell with a query (e.g. TIMESCALE.SELECT(), TIMEAGGREGATE())',
						optional: false
					},
					{
						type: 'Range or String',
						name: 'Target',
						description: 'A range or a shape name to display the data over. The shape name has to be put in quotes',
						optional: false
					},
					{
						type: 'String',
						name: 'Alignment',
						description: 'Define the alignment of the value table relative to the shape or range. Allowed alignment definitions are "right", "left" or "center". Default is "right"',
						optional: true
					}
				],
				return: {
					type: 'Boolean',
					description: 'TRUE.'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=SHOWVALUES(C6,K2:N7)',
							comment: 'If this formula is assigned to a shape event, queried data from C6 will be shown in a table covering K2:N7.'
						}
					]
				}
			}
		}
	},
};
